import React, { ReactNode } from 'react';
import { Card } from '../../../card/card';
import { Grid } from '../../../grid/grid';

interface GainLossLayoutProps {
    gainTitle: string;
    lossTitle: string;
    gainTooltip?: string;
    lossTooltip?: string;
    gainContent: React.ReactElement;
    lossContent: React.ReactElement;
    extra?: ReactNode;
}

export const GainLossLayout: React.FC<GainLossLayoutProps> = ({
    gainTitle,
    lossTitle,
    gainTooltip,
    lossTooltip,
    gainContent,
    lossContent,
    extra,
}) => {
    return (
        <div className="mt-small">
            {extra ? <div className="mb-vsmall flex justify-end">{extra}</div> : null}
            <Grid cols={{ xs: 1, vl: 2 }}>
                <Card title={gainTitle} tooltipText={gainTooltip} shadow="large">
                    {gainContent}
                </Card>
                <Card title={lossTitle} tooltipText={lossTooltip} shadow="large">
                    {lossContent}
                </Card>
            </Grid>
        </div>
    );
};
